import axios from '../axios/axios-auth'

export default class AlertsCoaService {

    getSensorsByOrg(orgId) {
        return axios.get(`/parametric-failures-service/v1/sensors/organization/${orgId}`).then(response => response.data)
    }

    getAlerts(orgId) {
        return axios.get(`/parametric-failures-service/v1/organization/${orgId}/failure`).then(response => response.data)
    }

    createAlert(orgId, params){
        return axios.post(`/parametric-failures-service/v1/organization/${orgId}/failure/simple`, params).then(response => response.data)
    }

    editAlert(orgId, params, failureId){
        return axios.patch(`/parametric-failures-service/v1/organization/${orgId}/failure/${failureId}/simple`, params).then(response => response.data)
    }

    getAlgorithmByVehicleModel(orgId, vehiclesManufacturerModelsId){
        return axios.get(`/parametric-failures-service/v1/organization/${orgId}/failure/algorithm/${vehiclesManufacturerModelsId}`).then(response => response.data)
    }

    getMachineAlertsProprietary(modelId, page, searchPattern){
        return axios.get(`/api/v3/vehicleModels/${modelId}/alertsCatalog?page=${page}&searchPattern=${searchPattern}`).then(response => response.data)
    }

    getMachineAlertsJ1939(page, searchPattern){
        return axios.get(`/api/v3/j1939AlertsCatalog?page=${page}&searchPattern=${searchPattern}`).then(response => response.data)
    }

    deleteMachineAlert(organization_id, model_id){
        return axios.delete(`/parametric-failures-service/v1/organization/${organization_id}/failure/machine/${model_id}`).then(response => response.data)
    }

    editAlgorithmAlerts(orgId, params){
        return axios.patch(`/parametric-failures-service/v1/organization/${orgId}/failure/algorithm`, params).then(response => response.data)
    }

    createMachineAlert(organization_id, params){
        return axios.post(`/parametric-failures-service/v1/organization/${organization_id}/failure/machine`, params).then(response => response.data)
    }

    editMachineAlert(organization_id, parametric_failure_id, params){
        return axios.patch(`/parametric-failures-service/v1/organization/${organization_id}/failure/machine/${parametric_failure_id}`, params).then(response => response.data)
    }

    getMachineAlertsInCOA(organization_id, model_id, params){
        return axios.post(`/parametric-failures-service/v1/organization/${organization_id}/failure/machine/${model_id}/status`, params).then(response => response.data)
    }

    createSensor(orgId, params){
        return axios.post(`/parametric-failures-service/v1/organization/${orgId}/sensor`, params).then(response => response.data)
    }

    deleteSensor(orgId, sensorId){
        return axios.delete(`/parametric-failures-service/v1/organization/${orgId}/sensor/${sensorId}`).then(response => response.data)
    }

    editSensor(orgId, params, sensorId){
        return axios.patch(`/parametric-failures-service/v1/organization/${orgId}/sensor/${sensorId}`, params).then(response => response.data)
    }

    getSPNlist(orgId){
        return axios.get(`/parametric-failures-service/v1/organization/${orgId}/dictionarySpn`).then(response => response.data)
    }

    createCompositeAlert(orgId, params){
        return axios.post(`/parametric-failures-service/v1/organization/${orgId}/failure/composite`, params).then(response => response.data)
    }

    editCompositeAlert(orgId, params, failureId){
        return axios.patch(`/parametric-failures-service/v1/organization/${orgId}/failure/composite/${failureId}`, params).then(response => response.data)
    }

    deleteCompositeAlert(orgId, failureId){
        return axios.delete(`/parametric-failures-service/v1/organization/${orgId}/failure/composite/${failureId}`).then(response => response.data)
    }

    deleteSimpleAlert(orgId, failureId){
        return axios.delete(`/parametric-failures-service/v1/organization/${orgId}/failure/${failureId}/simple`).then(response => response.data)
    }


    getAlertsCoa(orgId) {
        return axios.get(`/parametric-failures-service/v1/failuresCoa/organization/${orgId}`).then(response => response.data)
    }

    getHistoricalAlert(orgId, startDate, endDate) {
        return axios.get(`/parametric-failures-service/v1/failuresCoa/date/${startDate}/${endDate}/organization/${orgId}`).then(response => response.data)
    }

    getStatusHistoricalAlert(orgId, failuresId) {
        return axios.get(`/parametric-failures-service/v1/failureStatus/${failuresId}/organization/${orgId}`).then(response => response.data)
    }

    postStatusHistoricalAlert(orgId, failuresId, params) {
        return axios.post(`/parametric-failures-service/v1/failureStatus/${failuresId}/organization/${orgId}`, params).then(response => response.data)
    }

    deleteAlert(orgId, failureId){
        return axios.delete(`/parametric-failures-service/v1/organization/${orgId}/failure/${failureId}`).then(response => response.data)
    }

}
